import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip } from '@progress/kendo-react-charts';
import 'hammerjs';

export default function HomeFarmsPanel() {
    const { t } = useTranslation();


    const home = {
        "Granjas": 10,
        "Grupos": 5,
    }

    const series = [
        { category: 'Pedidos manuales', value: 25 },
        { category: 'Pedidos creadas', value: 20 },
        { category: 'Pedidos rechazados', value: 20 },
        { category: 'Pedidos confirmados', value: 25 },
        { category: 'Pedidos en curso', value: 10 }
    ];

    const tooltipRender = (props) => {
        const { category, value } = props.point || {};
        return (
            <div>
                <strong>{t(category)}:</strong> {value}
            </div>
        );
    };


    return (
        <div>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <b className="card-title m-0">{t("Global_Label_Text_Farms")}</b>
                    </div>

                    <div className="row no-gutters text-center">
                        <div className="col-md-6 card-body d-flex flex-column align-items-center">
                            <b className="card-title">{t("Global_Label_Text_Farms")}</b>
                            <b className="card-title">{home["Granjas"]}</b>
                        </div>
                        <div className="col-md-6 card-body d-flex flex-column align-items-center">
                            <b className="card-title">{t("Global_Label_Text_Groups")}</b>
                            <b className="card-title">{home["Grupos"]}</b>
                        </div>
                    </div>

                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="card">
                    <div className="card-header">
                        <b className="card-title m-0">{t("Pedidos")}</b>
                    </div>

                    <div className="row g-3">

                        <div className="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                            <div className="card m-4">
                                <div className="card-header">
                                    {series.map((item, index) => (
                                        <div key={index} className="d-flex align-items-center gap-2 mb-1 text-start">
                                            <span className="badge bg-primary">{item.value}</span>
                                            <span>{item.category}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-7 col-lg-8">
                            <div className="card-body p-2 p-md-3" style={{ minHeight: '300px' }}>
                                <Chart>
                                    <ChartTitle />
                                    <ChartLegend
                                        position="bottom"
                                        align="end"
                                        orientation="horizontal"
                                        className="mt-3"
                                    />
                                    <ChartTooltip render={tooltipRender} />
                                    <ChartSeries>
                                        <ChartSeriesItem
                                            type="pie"
                                            data={series}
                                            field="value"
                                            categoryField="category"
                                        />
                                    </ChartSeries>
                                </Chart>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    );
}